const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/about"],
    exact: true,
    component: "About",
  },
  {
    path: ["/projects"],
    exact: true,
    component: "Projects",
  },
  {
    path: ["/contact"],
    exact: true,
    component: "Contact",
  },
  {
    path: ["/projects/:id"],
    exact: true,
    component: "ProjectView",
  },
];

export default routes;
